import type { InvoiceTerms } from "@/features/invoices/types";

/** Payment-term labels, shared by the invoice editor and the live preview. */
export const TERMS_LABELS: Record<InvoiceTerms, string> = {
  RECEIPT: "Due on receipt",
  NET7: "Net 7",
  NET21: "Net 21",
  NET30: "Net 30",
};
